export const notificationConstants={
NOTIFICATION_TOTAL: 'NOTIFICATION_TOTAL',
NOTIFICATION_CLEAR: 'NOTIFICATION_CLEAR'
}